module.exports = __webpack_public_path__ + "img/logo.73a7a654.png";